import {Header} from "../layout/header.js";
import {Footer} from "../layout/footer.js";
import {GenericBanner} from "../components/genericbanner.js";


/**
 * React component to display the error page.
 */
export function ErrorPage() {
    /* TODO : This page could have an option for a detailed error messages. */
    return (
	<div>
          <Header />
          <GenericBanner title="Oops, something went wrong!" tagline="" />
          <div className="genericBody">
            We're sorry, but seems something went wrong. Try using your back button to go back to a page that worked.
          </div>
        <Footer />
	</div>
    );
}
